export default __webpack_public_path__ + "static/media/filter_search.c8f5061d.svg";